import { createReducer, INITIAL_STATE } from '@shared/redux';
import { getMobeesCampaignsApiConfig } from '@domain/partnerships/partners/mobees/campaign-table/campaign-table.api';
import { LOAD_STATE } from '@shared/axios';

export interface CampaignTableState {
    data: [];
    loadState: string,
    error: null,
}

export const GET_CAMPAIGNS_REQUEST_CALLED = '@mobees/newCampaign/GET_CAMPAIGNS_REQUEST_CALLED';
export const GET_CAMPAIGNS_REQUEST_SUCCEEDED = '@mobees/newCampaign/GET_CAMPAIGNS_REQUEST_SUCCEEDED';
export const GET_CAMPAIGNS_REQUEST_FAILED = '@mobees/newCampaign/GET_CAMPAIGNS_REQUEST_FAILED';

export const getMobeesCampaigns = () => ({
    type: GET_CAMPAIGNS_REQUEST_CALLED,
    actionTypes: {
        success: GET_CAMPAIGNS_REQUEST_SUCCEEDED,
        fail: GET_CAMPAIGNS_REQUEST_FAILED,
    },
    config: getMobeesCampaignsApiConfig(),
});

export const mobeesCampaignSelector = state => state.partnerships.mobees.campaignTable.data;
export const mobeesCampaignLoadingSelector = state => state.partnerships
    .mobees.campaignTable.loadState;

const initialState: CampaignTableState = {
    data: [],
    loadState: LOAD_STATE.LOADING,
    error: null,
};

export const campaignTableReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_CAMPAIGNS_REQUEST_CALLED]: state => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [GET_CAMPAIGNS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: action.payload.data,
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [GET_CAMPAIGNS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: [],
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
